export enum UserNotificationType {
  None = 'None',
  ExpiredPlants = 'ExpiredPlants',
}

export interface UserNotificationResponse {
  type: UserNotificationType,
  content?: string,
}